import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, X, Check } from 'lucide-react';
const objections = [{
  obj: 'No tengo tiempo para entrenar.',
  sol: 'Justamente por eso necesitás entrenar inteligente. La mayoría juega partidos pero nunca mejora. Un sistema estructurado te hace progresar entrenando poco.'
}, {
  obj: 'Ya juego hace años.',
  sol: 'Jugar hace años no es jugar correctamente. Muchos repiten los mismos errores, movimientos y decisiones durante muchísimo tiempo.'
}, {
  obj: 'Veo videos gratis en YouTube.',
  sol: 'Ver tips aislados no es tener un sistema. El problema del amateur no es falta de información: es falta de estructura y aplicación real.'
}, {
  obj: 'Mi problema es físico, no táctico.',
  sol: 'Muchos llegan tarde porque leen mal el juego. Moverte mejor tácticamente mejora muchísimo tu rendimiento físico en el partido.'
}, {
  obj: 'No soy competitivo.',
  sol: 'No necesitás competir para jugar mejor. La mayoría solo quiere dejar de frustrarse, rendir mejor, entender el juego y disfrutar más en cancha.'
}, {
  obj: 'Capaz no tengo talento.',
  sol: 'No necesitás más talento. Necesitás mejores decisiones, mejor posicionamiento, mejor lectura y menos errores evitables.'
}, {
  obj: 'Seguro es demasiado avanzado.',
  sol: 'Está pensado para amateurs e intermedios. Todo explicado paso a paso y aplicado a situaciones reales de partido.'
}, {
  obj: 'No sé si realmente voy a mejorar.',
  sol: 'Si seguís jugando acelerado, improvisando, sin estrategia y perdiendo puntos evitables, hay muchísimo margen de mejora.'
}, {
  obj: 'Ya entreno.',
  sol: 'Entrenar no siempre es progresar. Muchos entrenan mucho físico, partidos y horas, pero siguen tomando malas decisiones en cancha.'
}, {
  obj: 'No quiero otro ebook genérico.',
  sol: 'No es solo teoría. Es un sistema práctico con táctica, posicionamiento, lectura del rival, patrones, jugadas y estrategias aplicables directamente en partido.'
}];
export function Objections() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <section className="py-10 px-4 bg-brand-dark border-t border-white/5" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <div className="text-center mb-6" data-id="element-84">
          <span className="inline-block py-0.5 px-2.5 rounded-full bg-brand-green/15 border border-brand-green/30 text-brand-green font-body font-bold text-[10px] tracking-wider uppercase mb-2" data-id="element-85">
            Tus dudas, resueltas
          </span>
          <h2 className="font-display text-xl md:text-3xl text-white uppercase" data-id="element-86">
            ¿Tenés una <span className="text-brand-green" data-id="element-87">objeción</span>?
            Tenemos la respuesta.
          </h2>
        </div>

        <div className="space-y-2" data-id="element-88">
          {objections.map((item, idx) => {
          const isOpen = openIdx === idx;
          return <div key={idx} className={`rounded-lg overflow-hidden border transition-colors ${isOpen ? 'border-brand-green/50 bg-brand-card' : 'border-white/10 bg-brand-card/50 hover:border-brand-green/30'}`} data-id="element-89">
                <button onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center gap-2 px-4 py-2.5 text-left" data-id="element-90">
                  <X className="w-3.5 h-3.5 text-red-400 shrink-0" strokeWidth={3} data-id="element-91" />
                  <span className="flex-1 font-body text-sm text-white font-medium" data-id="element-92">
                    {item.obj}
                  </span>
                  <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform shrink-0 ${isOpen ? 'rotate-180 text-brand-green' : ''}`} data-id="element-93" />
                </button>

                <AnimatePresence data-id="element-94">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-95">
                      <div className="px-4 pb-3 pt-1 flex items-start gap-2 border-t border-white/5" data-id="element-96">
                        <Check className="w-3.5 h-3.5 text-brand-green shrink-0 mt-1" strokeWidth={3} data-id="element-97" />
                        <p className="font-body text-xs md:text-sm text-gray-300 leading-relaxed" data-id="element-98">
                          {item.sol}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}